/* eslint-disable @typescript-eslint/no-deprecated */
const macOSPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
const isMacOS = () => macOSPlatforms.includes(navigator.platform);

const isWindows = () => navigator.platform.includes('Win');

const isAndroid = () => navigator.userAgent.toLowerCase().includes('android');

const isIOS = () =>
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
    (navigator.userAgent.includes('Mobile') && navigator.userAgent.includes('Safari'))) &&
  !window.MSStream &&
  !isAndroid();

const isMobileSafari = () => {
  const ua = window.navigator.userAgent;
  const iOS = !!/iPad/i.exec(ua) || !!/iPhone/i.exec(ua);
  const webkit = !!/WebKit/i.exec(ua);

  return iOS && webkit && !/CriOS/i.exec(ua);
};

const isMobile = () => isAndroid() || isIOS();

const platformsConsts = {
  macos: 'macos',
  windows: 'windows',
  ios: 'ios',
  android: 'android',
} as const;

const resolvePlatform = (): keyof typeof platformsConsts | undefined => {
  if (isMacOS()) {
    return platformsConsts.macos;
  }
  if (isWindows()) {
    return platformsConsts.windows;
  }
  if (isAndroid()) {
    return platformsConsts.android;
  }
  if (isIOS()) {
    return platformsConsts.ios;
  }
};

export { isIOS, isAndroid, isMacOS, isWindows, isMobile, isMobileSafari, resolvePlatform, platformsConsts };
